import { SvgComponentProps } from "@/src/types/SVGPropType";
import * as React from "react";
const Hobby5SVG: React.FC<SvgComponentProps> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={12}
    height={17}
    fill="none"
    {...props}
  >
    <path
      fill="#EDEDED"
      fillRule="evenodd"
      d="M1.5 10.338v-5.47c.19-.053.393-.106.607-.162l.459-.12c.586-.158 1.23-.345 1.823-.605.584-.257 1.168-.605 1.611-1.113.443.508 1.027.856 1.611 1.113.593.26 1.237.447 1.823.604.16.043.312.083.46.12.213.057.415.11.606.163v5.47a3.75 3.75 0 0 1-2.01 3.322L6 14.963l-2.49-1.305a3.75 3.75 0 0 1-2.01-3.321Zm3.378-8.466c.227-.265.372-.594.372-1.061h1.5c0 .467.145.796.372 1.06.242.283.608.524 1.092.736.482.212 1.032.375 1.608.53l.409.107c.432.112.874.228 1.256.355L12 3.77v6.568a5.25 5.25 0 0 1-2.814 4.65l-2.838 1.487-.348.182-.348-.182-2.838-1.487A5.25 5.25 0 0 1 0 10.338V3.77l.513-.171c.382-.127.824-.243 1.256-.355l.409-.108c.576-.154 1.126-.317 1.608-.529.484-.212.85-.453 1.092-.735ZM8.53 8.34l.53-.53L8 6.75l-.53.53L5 9.75l-.47-.47L4 8.75 2.94 9.81l.53.53 1 1a.75.75 0 0 0 1.06 0l3-3Z"
      clipRule="evenodd"
    />
  </svg>
);
export default Hobby5SVG;
